/* eslint-disable react/function-component-definition */
/* eslint-disable react/no-unstable-nested-components */
import React, { useState, useEffect, useRef, useMemo } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useCookies } from "react-cookie";
import { useNavigate, Link, useMatch, useLocation } from "react-router-dom";
import { useMutation, useQuery } from "@apollo/client";
import DropdownButton from "react-bootstrap/DropdownButton";
import Select from "react-select";
import { useOktaAuth } from "@okta/okta-react";
import companyLogo from "../assets/img/logo2.png";
import globePic from "../assets/img/globe.svg";
import userPic from "../assets/img/user.svg";
import HowToIcon from "../assets/img/HowToIcon.svg";
import noFillHeartPic from "../assets/img/heart-no-fill.svg";
import { CHANGE_USER_INFO } from "../services/graphql/migrations";
import SearchIcon from "../assets/img/magnifying-glass.svg";
import signOutPic from "../assets/img/sign-out.svg";
import downloadIcon from "../assets/img/downloads/downloadIcon.svg";
import { useAppDispatch, useAppSelector } from "../store";
import { RootState } from "../rootReducer";
import { getRegionAndLanguageData } from "../utils/regionAndLanguagesGraphQL";
import { setUser, clearUser } from "../pages/auth/userSlice";
import { clearToken, setAuthState } from "../pages/auth/authSlice";
import SecureLS from "../utils/SecureStorage";
import HamburgerMenuIcon from "../assets/img/hamburgerMenu.svg";
import http from "../services/api";
import {
  FavoriteVideoThumbnailData,
  FavoriteVideoThumbnailRequest,
  FavoriteVideoThumbnailResponse,
  VideoThumbNails,
  FilterOptionsInfo,
  Options,
} from "../models/interfaces/common";
import { addVideoThumbNails } from "../pages/favoriteSlice";
import { getDownloadsCounter, getFavoritesApiCall } from "../utils/catalog";
import {
  FavoriteInfoInterface,
  setCurrentFolderId,
  setDefaultFolderId,
  setFavorite,
} from "../pages/newFavoriteSlice";
import { scrollToTop, showAlert, showGreenAlert } from "../util";
import {
  assignSelectedAge,
  assignSelectedAssetType,
  assignSelectedAssetTag,
  assignSelectedBrand,
  assignSelectedColorCode,
  assignSelectedColorName,
  assignSelectedFabricContent,
  assignSelectedFabricName,
  assignSelectedFileType,
  assignSelectedFilters,
  assignSelectedGender,
  assignSelectedLabelName,
  assignSelectedImageResolution,
  assignSelectedSilhouette,
  assignSelectedStyle,
  assignSelectedTotalModel,
  assignLastSelectedOption,
  removeSelectedFilters,
} from "../pages/filterOptionsSlice";
import { removeAllFilters } from "../pages/filterSlice";
import { setAssetIdList } from "../pages/assetsSlice";
import user from "../services/mirage/routes/user";
import {
  removeProcesses,
  setUnreadMessages,
} from "../pages/multipleAssetDownloadSlice";

interface HeaderProps {
  toggleHamburgerMenu: () => void;
  isMobile: boolean;
}

export default function Header({ toggleHamburgerMenu, isMobile }: HeaderProps) {
  const UserInfoSlice = useSelector((state: RootState) => state.user);
  const userId = useSelector((state: RootState) => state.user?.id);
  const FavoriteSlice = useSelector((state: RootState) => state.favorite);
  const isHowToPage = useMatch("/howto/:howToPage");
  const isSharedPage = useMatch("/shared/:token");
  let regionDropDown = useRef<HTMLDivElement>(null);
  const [cookies, setCookie, removeCookie] = useCookies([
    "rememberMeEmail",
    "rememberMePassword",
    "JSESSIONID",
    "sid",
    "ln",
    "srefresh",
    "enduser_version",
    "proximity_cc91527febee5e661206adb5f3f102b3",
    "okta-oauth-nonce",
    "t",
    "Okta_Verify_Autopush_978541678",
    "DT",
    "okta-oauth-state",
    "okta-oauth-redirect-params",
  ]);
  const { oktaAuth } = useOktaAuth();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [showRegionLanguage, setshowRegionLanguage] = useState<Boolean>(false);
  // Local state for temporary selections in dropdown (before clicking Continue)
  const [tempSelectedRegion, setTempSelectedRegion] = useState<any>(null);
  const [tempSelectedLanguage, setTempSelectedLanguage] = useState<any>(null);

  const source = axios.CancelToken.source();

  const [counter, setCounter] = useState<number>(0);
  const unreadMessages = useAppSelector(
    (state) => state.multipleAssetsDownload.unreadMessages
  );

  const [updateUserInfo] = useMutation(CHANGE_USER_INFO);

  const [favoriteAssetIds, setFavoriteAssetIds] = useState<string[] | null>(
    null
  );

  const [showSearch, setShowSearch] = useState(false);

  const setSelectedAssetType = (value: Options[]) =>
    dispatch(assignSelectedAssetType(value));
  const setSelectedAssetTag = (value: Options[]) =>
    dispatch(assignSelectedAssetTag(value));
  const setSelectedGender = (value: Options[]) =>
    dispatch(assignSelectedGender(value));
  const setSelectedStyle = (value: Options[]) =>
    dispatch(assignSelectedStyle(value));
  const setSelectedAge = (value: Options[]) =>
    dispatch(assignSelectedAge(value));
  const setSelectedBrand = (value: Options[]) =>
    dispatch(assignSelectedBrand(value));
  const setSelectedColorCode = (value: Options[]) =>
    dispatch(assignSelectedColorCode(value));
  const setSelectedColorName = (value: Options[]) =>
    dispatch(assignSelectedColorName(value));
  const setSelectedFabricContent = (value: Options[]) =>
    dispatch(assignSelectedFabricContent(value));
  const setSelectedFabricName = (value: Options[]) =>
    dispatch(assignSelectedFabricName(value));
  const setSelectedFileType = (value: Options[]) =>
    dispatch(assignSelectedFileType(value));
  const setSelectedLabelName = (value: Options[]) =>
    dispatch(assignSelectedLabelName(value));
  const setSelectedImageResolution = (value: Options[]) =>
    dispatch(assignSelectedImageResolution(value));
  const setSelectedSilhouette = (value: Options[]) =>
    dispatch(assignSelectedSilhouette(value));
  const setSelectedTotalModel = (value: Options[]) =>
    dispatch(assignSelectedTotalModel(value));
  const setSelectedFilters = (value: FilterOptionsInfo[]) =>
    dispatch(assignSelectedFilters(value));
  const setLastSelectedOption = (item: string) =>
    dispatch(assignLastSelectedOption(item));

  // Remove all filters
  const removeFilters = () => dispatch(removeAllFilters());
  const removeActiveFilters = () => dispatch(removeSelectedFilters());
  const setAssetIds = (ids: string[]) => dispatch(setAssetIdList(ids));

  const clearAllCookies = () => {
    document.cookie =
      "username=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  };

  const deleteRememberMeCookies = () => {
    removeCookie("rememberMeEmail");
    removeCookie("rememberMePassword");
  };

  const deleteOktaCookies = () => {
    removeCookie("JSESSIONID");
    removeCookie("sid");
    removeCookie("ln");
    removeCookie("srefresh");
    removeCookie("enduser_version");
    removeCookie("proximity_cc91527febee5e661206adb5f3f102b3");
    removeCookie("okta-oauth-nonce");
    removeCookie("t");
    removeCookie("Okta_Verify_Autopush_978541678");
    removeCookie("DT");
    removeCookie("okta-oauth-state");
    removeCookie("okta-oauth-redirect-params");
  };

  const {
    getUpdatedLanguageOptions,
    allRegionList,
    allLanguageList,
    loading,
    error,
    data,
    defaultRegion,
    defaultLanguage,
  } = getRegionAndLanguageData([]);

  const getCounterForDownloads = async () => {
    if (userId === undefined) return;
    const response = await getDownloadsCounter(
      Number(userId),
      "expirationDate",
      "asc",
      source
    );

    if (response && typeof response === "number") {
      dispatch(setUnreadMessages(response));
    }
  };

  // Get current region display from Redux (syncs with Region.tsx updates)
  const currentRegionDisplay = useMemo(() => {
    if (UserInfoSlice?.primaryRegion && allRegionList) {
      const region = allRegionList.find(
        (r: any) => r.value.toString() === UserInfoSlice.primaryRegion
      );
      return region?.label || defaultRegion?.label || "";
    }
    return defaultRegion?.label || "";
  }, [UserInfoSlice?.primaryRegion, allRegionList, defaultRegion]);

  useEffect(() => {
    if (FavoriteSlice.rawFavorites) {
      const temp: string[] = [];
      FavoriteSlice.rawFavorites.forEach((item) => {
        if (item.assetsListFav)
          item.assetsListFav.forEach((asset: any) => {
            if (asset.type === "video") temp.push(asset.id);
          });
      });
      setFavoriteAssetIds([...temp]);
    }
  }, [FavoriteSlice.rawFavorites]);

  useEffect(() => {
    if (favoriteAssetIds) {
      const path = "/api/favoritevideothumbnails";

      http
        .post<
          FavoriteVideoThumbnailRequest,
          FavoriteVideoThumbnailResponse
        >(path, { videoIds: favoriteAssetIds })
        .then((res) => {
          const response: FavoriteVideoThumbnailData[] = res
            ? (res.data as unknown as FavoriteVideoThumbnailData[])
            : [];
          const temp: VideoThumbNails = {};
          response.forEach((asset) => {
            temp[asset.assetId] = asset.videoThumbnailPath;
          });
          dispatch(addVideoThumbNails(temp));
        });
    }
  }, [favoriteAssetIds]);

  // Get the search value from the URL
  const location = useLocation();
  const currentSearch = new URLSearchParams(location.search).get("search");
  const { t, i18n } = useTranslation("common");
  const [searchValue, setSetSearchValue] = useState(currentSearch ?? "");

  const updateRegionChanges = async () => {
    if (!tempSelectedRegion || !tempSelectedLanguage) return;

    // Check if region actually changed
    const currentRegionValue = UserInfoSlice?.primaryRegion?.toString();
    const newRegionValue = (tempSelectedRegion as any)?.value?.toString();
    const regionChanged = currentRegionValue !== newRegionValue;

    try {
      await updateUserInfo({
        variables: {
          id: Number(UserInfoSlice?.id),
          userInfo: {
            preferredLanguage: (tempSelectedLanguage as any)?.value,
            primaryRegion: (tempSelectedRegion as any)?.value,
          },
        },
      });

      const userInfo = {
        ...UserInfoSlice,
        preferredLanguage: (tempSelectedLanguage as any)?.value,
        primaryRegion: (tempSelectedRegion as any)?.value,
      };
      dispatch(setUser(userInfo));
      i18n.changeLanguage((tempSelectedLanguage as any)?.value);

      // Clear temp selections after successful update
      setTempSelectedRegion(null);
      setTempSelectedLanguage(null);

      // Close dropdown
      setshowRegionLanguage(false);
      const element: HTMLElement = document.getElementById(
        "headerAccountRegion"
      ) as HTMLElement;
      if (element) element.click();

      showGreenAlert(t("Updated Successfully"));
      emptyFilterAttributes();

      // Redirect to home page ONLY if region changed
      if (regionChanged) {
        navigate("/");
      }
    } catch (error) {
      console.error("Error updating user info:", error);
      showAlert(
        "error",
        "Error. Could not update language or region successfully"
      );
    }
  };

  const emptyFilterAttributes = () => {
    setSelectedAssetType([]);
    setSelectedAssetTag([]);
    setSelectedBrand([]);
    setSelectedImageResolution([]);
    setSelectedFileType([]);
    setSelectedStyle([]);
    setSelectedSilhouette([]);
    setSelectedColorName([]);
    setSelectedColorCode([]);
    setSelectedGender([]);
    setSelectedAge([]);
    setSelectedFabricName([]);
    setSelectedFabricContent([]);
    setSelectedTotalModel([]);
    setSelectedLabelName([]);
    setSelectedFilters([]);
    setLastSelectedOption("");
  };

  const handleLogout = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    event.stopPropagation();
    deleteRememberMeCookies();
    deleteOktaCookies();
    SecureLS.removeItem("user");
    SecureLS.removeItem("okta-cache-storage");
    SecureLS.removeItem("okta-token-storage");
    oktaLogout();
    clearAllCookies();
    dispatch(removeProcesses());
    // Clear Redux state
    dispatch(clearToken());
    dispatch(setAuthState(false));
    dispatch(clearUser());
  };

  const handleRegionChange = (region: any) => {
    setTempSelectedRegion(region);
    setTempSelectedLanguage(null);
    // Auto-select first available language when region changes
    if (getUpdatedLanguageOptions && region) {
      const languages = getUpdatedLanguageOptions(region);
      if (languages && languages.length > 0) {
        setTempSelectedLanguage(languages[0]);
      }
    }
  };

  const handleLanguageChange = (lang: any) => {
    // If no temp region selected, use current Redux region or default
    if (!tempSelectedRegion) {
      const currentRegion = UserInfoSlice?.primaryRegion
        ? allRegionList.find(
            (r: any) => r.value.toString() === UserInfoSlice.primaryRegion
          )
        : defaultRegion;
      if (currentRegion) {
        setTempSelectedRegion(currentRegion);
      }
    }
    setTempSelectedLanguage(lang);
  };

  const handleSearch = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    removeFilters();
    removeActiveFilters();
    setAssetIds([]);
    navigate(`/search?search=${searchValue}`, {
      state: { detail: searchValue },
    });
    scrollToTop();
  };

  const onSearchValueChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSetSearchValue(event.target.value);
  };

  // sign out okta
  const oktaLogout = async () => {
    // Will redirect to Okta to end the session then redirect back to the configured `postLogoutRedirectUri`\
    if (oktaAuth) {
      // console.log("okta auth: ", oktaAuth);
      // await oktaAuth.signOut();
    }
    navigate(`/login`);
  };
  const oktaDeleteSessions = async () => {
    oktaAuth.tokenManager.clear();
  };

  // Get current selections: use temp if set, otherwise use Redux values
  const currentRegion = useMemo(() => {
    if (tempSelectedRegion) return tempSelectedRegion;
    if (UserInfoSlice?.primaryRegion && allRegionList) {
      return (
        allRegionList.find(
          (r: any) => r.value.toString() === UserInfoSlice.primaryRegion
        ) || defaultRegion
      );
    }
    return defaultRegion;
  }, [
    tempSelectedRegion,
    UserInfoSlice?.primaryRegion,
    allRegionList,
    defaultRegion,
  ]);

  const currentLanguage = useMemo(() => {
    if (tempSelectedLanguage) return tempSelectedLanguage;
    if (UserInfoSlice?.preferredLanguage && allLanguageList) {
      return (
        allLanguageList.find(
          (l: any) => l.value.toString() === UserInfoSlice.preferredLanguage
        ) || defaultLanguage
      );
    }
    return defaultLanguage;
  }, [
    tempSelectedLanguage,
    UserInfoSlice?.preferredLanguage,
    allLanguageList,
    defaultLanguage,
  ]);

  // Get available languages for the selected region
  const availableLanguages = useMemo(() => {
    if (getUpdatedLanguageOptions && currentRegion) {
      return getUpdatedLanguageOptions(currentRegion);
    }
    return allLanguageList;
  }, [getUpdatedLanguageOptions, currentRegion, allLanguageList]);

  const RegionLanguages = (
    <>
      <Select
        classNamePrefix="regular-looking-dropdown"
        className="w-100"
        name="region"
        onChange={handleRegionChange}
        options={allRegionList}
        isMulti={false}
        value={currentRegion}
      />
      <Select
        classNamePrefix="regular-looking-dropdown"
        className="w-100 mt-3 mb-2"
        name="language"
        onChange={handleLanguageChange}
        options={availableLanguages}
        isMulti={false}
        value={currentLanguage}
        isDisabled={!currentRegion}
      />
    </>
  );

  const defaultFavoriteFolderId = useAppSelector(
    (state) => state.newFavorite.defaultFolderId
  );
  const currentFavoriteFolderId = useAppSelector(
    (state) => state.newFavorite.currentFolderId
  );
  const favorites = useAppSelector((state) => state.newFavorite.favorite);

  useEffect(() => {
    let tempCounter = 0;
    Object.values(favorites).forEach((item) => {
      tempCounter += item.assets.length;
    });
    if (tempCounter !== counter) setCounter(tempCounter);
  }, [favorites]);

  useEffect(() => {
    getCounterForDownloads();
  }, [userId]);

  useEffect(() => {
    if (userId && userId !== 0) {
      getFavoritesApiCall(
        userId as number,
        defaultFavoriteFolderId,
        currentFavoriteFolderId,
        (value: FavoriteInfoInterface) => dispatch(setFavorite(value)),
        (id: string) => dispatch(setDefaultFolderId(id)),
        (id: string) => dispatch(setCurrentFolderId(id))
      );
    }
  }, [userId]);

  const secureLS = SecureLS.getItem("user");
  const dataValue = secureLS ? JSON.parse(secureLS) : null;

  const toggleSidebar = () => {
    toggleHamburgerMenu();
  };

  const toggleSearch = () => {
    setShowSearch(!showSearch);
  };

  const renderChangeRegionIcon = () => (
    <span>
      <img width="22" src={globePic} alt="User" /> <b>{currentRegionDisplay}</b>
    </span>
  );

  const HamburgerMenuButton = () => (
    <button className="header-button" type="button" onClick={toggleSidebar}>
      <img src={HamburgerMenuIcon} alt="HamburgerMenu" />
    </button>
  );

  const SearchButton = () => (
    <button className="header-button" type="button" onClick={toggleSearch}>
      <img src={SearchIcon} alt="Search" />
    </button>
  );

  const handleDropdownToggle = (isOpen: boolean) => {
    setshowRegionLanguage(isOpen);
    // When opening dropdown, initialize temp selections with current Redux values
    if (isOpen) {
      if (UserInfoSlice?.primaryRegion && allRegionList) {
        const region = allRegionList.find(
          (r: any) => r.value.toString() === UserInfoSlice.primaryRegion
        );
        if (region) setTempSelectedRegion(region);
      } else if (defaultRegion) {
        setTempSelectedRegion(defaultRegion);
      }

      if (UserInfoSlice?.preferredLanguage && allLanguageList) {
        const language = allLanguageList.find(
          (l: any) => l.value.toString() === UserInfoSlice.preferredLanguage
        );
        if (language) setTempSelectedLanguage(language);
      } else if (defaultLanguage) {
        setTempSelectedLanguage(defaultLanguage);
      }
    } else {
      // When closing dropdown without saving, reset temp selections so they sync with Redux next time
      // (Note: Continue button already clears them before closing)
      setTempSelectedRegion(null);
      setTempSelectedLanguage(null);
    }
  };

  const renderChangeRegion = () => (
    <DropdownButton
      show={showRegionLanguage as boolean}
      onToggle={handleDropdownToggle}
      id="headerAccountRegion"
      title={renderChangeRegionIcon()}
      autoClose="outside"
      ref={(dropdownRef: any) => {
        regionDropDown = dropdownRef;
      }}
    >
      <h5 className="mb-3">{t("Change Region")}</h5>
      {RegionLanguages}
      <p>{t("Not all styles or brands will be available in every region.")}</p>
      <button
        className="btn btn-blue"
        type="button"
        disabled={!(!!tempSelectedRegion && !!tempSelectedLanguage)}
        onClick={updateRegionChanges}
      >
        {t("Continue")}
      </button>
    </DropdownButton>
  );

  const MobileHeaderUserTools = useMemo(() => {
    if (showSearch) {
      return (
        <div className="search mt-3">
          <form action="" onSubmit={handleSearch}>
            <input
              type="text"
              className="search-input form-control"
              id="exampleFormControlInput1"
              placeholder={t("Search...")}
              value={searchValue}
              onChange={onSearchValueChange}
            />
          </form>
        </div>
      );
    }
    return null;
  }, [showSearch, searchValue, handleSearch, onSearchValueChange]);

  const renderHeaderUserTools = () => {
    if ((isSharedPage || isHowToPage) && !dataValue) {
      return (
        <div className="shared-profile-links">
          <button
            type="button"
            className="btn btn-lg btn-blue"
            onClick={() => navigate("/login")}
          >
            Log In
          </button>
          <button
            className="btn btn-lg shared-btn-reversed btn-blue"
            type="button"
            onClick={() => navigate("/register")}
          >
            Sign Up
          </button>
        </div>
      );
    }
    return (
      <>
        <div className="search">
          <form action="" onSubmit={handleSearch}>
            <input
              type="text"
              className="search-input form-control"
              id="exampleFormControlInput1"
              placeholder={t("Search...")}
              value={searchValue}
              onChange={onSearchValueChange}
            />
          </form>
        </div>
        <div className="account-links">
          <Link to="/howto/register" className="px-1 me-3">
            <img className="howto" src={HowToIcon} alt="HowToIcon" />
          </Link>
          <Link to="/account/profile" className="user px-1 me-3">
            <img src={userPic} alt="User" />
          </Link>
          {/* <img className="" width="22" src={globePic} alt="User" /> */}
          {/* {renderChangeRegionIcon()} */}

          <div className="region">{renderChangeRegion()}</div>
          <Link
            to="/downloads"
            className="user like-toggle position-relative ms-2 me-3"
          >
            <img
              width="26"
              className="img-toggle d-block"
              src={downloadIcon}
              alt="Like"
            />
            <div className="circle-count"> {unreadMessages} </div>
          </Link>
          <Link
            to="/favorites"
            className="user like-toggle position-relative ms-3 me-3"
          >
            <img
              width="26"
              className="img-toggle d-block"
              src={noFillHeartPic}
              alt="Like"
            />
            <div className="circle-count"> {counter} </div>
          </Link>
          <Link
            to="/login"
            className="user ms-3"
            onClick={(event: React.MouseEvent<HTMLAnchorElement>) => {
              handleLogout(event);
            }}
          >
            <img src={signOutPic} alt="Sign-Out" />
          </Link>
        </div>
      </>
    );
  };

  return (
    <header className="d-flex flex-column flex-md-row justify-content-between align-items-center">
      <div
        className="d-flex flex-sm-row justify-content-between align-items-center"
        style={{ width: isMobile ? "100%" : "auto" }}
      >
        {isMobile && userId ? <HamburgerMenuButton /> : <div />}
        <div
          className="logo mb-md-0"
          onClick={() => {
            scrollToTop();
            if (window.location.pathname === "/downloads") {
              dispatch(removeProcesses());
            }
            if (
              !userId ||
              userId === 0 ||
              window.location.pathname.includes("/howto")
            ) {
              navigate("/login");
            } else {
              navigate("/");
            }
          }}
          role="button"
          tabIndex={-1}
        >
          <img src={companyLogo} alt="Gildan Brands" />
        </div>
        {isMobile && userId ? <SearchButton /> : <div />}
      </div>
      {isMobile ? MobileHeaderUserTools : renderHeaderUserTools()}
    </header>
  );
}
